import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm
} from './planoContaActions';

const listaTipo = [
    {
        id: 'RECEITA',
        valor: 'Receita'
    },
    {
        id: 'DEDUCAO',
        valor: 'Dedução'
    },
    {
        id: 'CUSTO',
        valor: 'Custo'
    },
    {
        id: 'DESPESA',
        valor: 'Despesa'
    },
    {
        id: 'IMPOSTO',
        valor: 'Imposto'
    },
    {
        id: 'RESULTADO',
        valor: 'Resultado'
    }
];

const listaNatureza = [
    {
        id: 'DEBITO',
        valor: 'Débito'
    },
    {
        id: 'CREDITO',
        valor: 'Crédito'
    }
];

let PlanoContaForm = props => {

    const formulario =
        props.formularioValues || {};

    const readOnly = props.excluir
        ? 'readOnly'
        : '';

    const listaPlanoContaPai = (
        props.listaPlanoConta || []
    ).filter(item =>
        Number(item.id) !== Number(formulario.id)
    );

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='codigo'
                            component={LabelAndInput}
                            label='Código *'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe'
                            cols='12 9 9 9'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='id_plano_conta_pai'
                            options={listaPlanoContaPai}
                            component={Select}
                            label='Conta Pai'
                            placeholder='Selecione'
                            cols='12 6 6 6'
                            readOnly={readOnly}
                        />

                        <Field
                            name='tipo'
                            options={listaTipo}
                            component={Select}
                            label='Tipo *'
                            placeholder='Selecione'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='natureza'
                            options={listaNatureza}
                            component={Select}
                            label='Natureza *'
                            placeholder='Selecione'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='ordem'
                            component={LabelAndInputNumber}
                            label='Ordem *'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            casas={0}
                            readOnly={readOnly}
                        />

                        <Field
                            name='aceita_lancamento'
                            component={LabelAndCheckbox}
                            label='Aceita Lançamento'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            minWidth={180}
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndInput}
                            label='Observação'
                            placeholder='Informe'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')
                                }
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

PlanoContaForm = reduxForm({
    form: 'planoContaForm',
    destroyOnUnmount: false
})(PlanoContaForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,

    formularioValues:
        getFormValues('planoContaForm')(state),

    registro:
        state.planoConta.registro,

    listaPlanoConta:
        state.planoConta.listaSelect
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlanoContaForm);